"use strict";

exports.__esModule = true;
var _UserEditor = require("./UserEditor");
Object.keys(_UserEditor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UserEditor[key]) return;
  exports[key] = _UserEditor[key];
});